import { PerimetersService } from './perimeters.service';
import { Injectable } from '@angular/core';
import { APIService, KPI } from '../api';
import {
  BehaviorSubject, Observable, switchMap, combineLatest, shareReplay, distinctUntilChanged, debounceTime, map, startWith,
} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FidjiActService {

  constructor(
    private apiService: APIService,
    private perimetersService: PerimetersService,
  ) { }

  private _reloadData: BehaviorSubject<number> = new BehaviorSubject(0);
  public reloadData$: Observable<number> = this._reloadData.asObservable();

  public reloadData() {
    this._reloadData.next(Date.now());
  }

  private _fidjiActTransposed: Observable<KPI.FidjiActTransposed>;
  public get fidjiActTransposed$(): Observable<KPI.FidjiActTransposed> {
    if (!this._fidjiActTransposed) {
      this._fidjiActTransposed = combineLatest([
        this.reloadData$.pipe(distinctUntilChanged()),
        this.perimetersService.perimeters$.pipe(
          startWith([] as KPI.Perimeter[]),
          map((perimeters) => perimeters.map((perimeter) => perimeter.id)),
          distinctUntilChanged((a, b) => a.join(',') === b.join(',')),
        ),
      ]).pipe(
        debounceTime(50),
        switchMap(([, siteIds]) => this.apiService.get_fidji_act_transposed(siteIds)),
        shareReplay(1),
      );
    }
    return this._fidjiActTransposed;
  }
}
